import { MigrateEntityInDto, MigrateEntityOutDto } from "../../../types/enargas.dto"

export const MIGRATE_ENTITY = 'MIGRATE_ENTITY'
export const MIGRATE_ENTITY_SUCCESS = 'MIGRATE_ENTITY_SUCCESS'
export const MIGRATE_ENTITY_ERROR = 'MIGRATE_ENTITY_ERROR'
export const RESET_MIGRATE_ENTITY = 'RESET_MIGRATE_ENTITY'

export interface MigrateEntity {
  type: typeof MIGRATE_ENTITY
  payload: MigrateEntityOutDto
}

export interface MigrateEntitySuccess {
  type: typeof MIGRATE_ENTITY_SUCCESS
  payload: any
}

export interface MigrateEntityError {
  type: typeof MIGRATE_ENTITY_ERROR
  payload: string | boolean
}

export interface ResetMigrateEntity {
  type: typeof RESET_MIGRATE_ENTITY
  payload: null
}

export interface State {
  data: MigrateEntityInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | MigrateEntity
  | MigrateEntitySuccess
  | MigrateEntityError
  | ResetMigrateEntity
